<template>
  <div id="byan">
    <el-card class="box-card newbb">
      <div slot="header" class="clearfix">
        <span>统计查询&nbsp;/&nbsp;办宴统计</span>
      </div>
      <div>
        <Week @childFn="parentFn"></Week>
        <el-date-picker
          align="right"
          unlink-panels
          :picker-options="pickerOptions"
          v-model="zctime"
          type="daterange"
          value-format="yyyy-MM-dd"
          style="margin: 0 26px 0 0"
          @blur="time"
          range-separator="至"
          start-placeholder="办宴开始日期"
          end-placeholder="办宴结束日期"
        >
        </el-date-picker>
        <el-button
          type="primary"
          element-loading-text="加载中..."
          element-loading-background="rgba(0, 0, 0, 0.4)"
          v-loading.fullscreen.lock="fullscreenLoading"
          @click="query"
          >查询</el-button
        >
        <el-button type="info" @click="reset">重置</el-button>
      </div>
    </el-card>
    <el-card class="box-card bdechart">
      <div slot="header" class="clearfix">
        <span>区域：{{ seekCity }}</span>
        <Screendata @choice="timec"></Screendata>
      </div>
      <div class="overview">
        <p>
          <span>办宴次数</span
          ><span
            ><i class="mgr" id="time1">{{ statistics.bb }}</i
            >次</span
          >
        </p>
        <p>
          <span>检查次数</span
          ><span
            ><i class="mgr" id="time2">{{ statistics.cs }}</i
            >次</span
          >
        </p>
        <p>
          <span>办宴桌数</span
          ><span
            ><i class="mgr" id="time3">{{ statistics.zs }}</i
            >桌</span
          >
        </p>
        <p>
          <span>参宴人数</span
          ><span
            ><i class="mgr" id="time4">{{ statistics.rs }}</i
            >人</span
          >
        </p>
      </div>
      <div id="main1" style="width: 100%; height: 370px"></div>
    </el-card>
    <el-card class="box-card bdechart">
      <div slot="header" class="clearfix newbbtit">
        <span>办宴统计明细表</span>
        <Xlsx :name="formname"></Xlsx>
      </div>
      <el-table
        :data="tableData6"
        id="exportTab"
        border
        stripe
        :row-class-name="tableRowClassName"
        style="width: 100%"
      >
        <el-table-column prop="areaName" width="200" label="区域">
        </el-table-column>
        <el-table-column prop="total1" label="办宴数"> </el-table-column>
        <el-table-column prop="total2" label="检查数"> </el-table-column>
        <el-table-column prop="total3" label="办宴桌数"> </el-table-column>
        <el-table-column prop="total4" label="参宴人数"> </el-table-column>
      </el-table>
      <div class="paging">
        <span
          >共 <i class="pagingNum">{{ listnum }}</i> 条</span
        >
        <Paging :gopage="listnum" @pag="pag"></Paging>
      </div>
    </el-card>
  </div>
</template>
<script>
import Week from "@/components/Week";
import Screendata from "@/components/Screendata";
import Xlsx from "@/components/Xlsx";
import echarts from "echarts";
import Paging from "@/components/Paging";
export default {
  name: "byan",
  components: {
    Week,
    Screendata,
    Xlsx,
    Paging,
  },
  data() {
    return {
      areaId: "",
      zctime: "",
      userdata: {},
      pageNum: 1,
      pageSize: 10,
      chart: [],
      total: {}, //总计
      tableData6: [],
      stat: "", //定义一个查询
      nowtime: "",
      listnum: 1,
      statistics: { bb: 0, cs: 0, zs: 0, rs: 0 },
      formname: JSON.stringify({ name: "办宴统计明细表", hint: "" }),
      fullscreenLoading: false,
      level: "",
      seekCity: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  created() {
    this.load();
    this.seekCity = this.userdata.areasName;
  },
  mounted() {},
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (row.areaName == "合计") {
        return "re";
      } else if (rowIndex === 3) {
        return "success-row";
      }
      return "";
    },
    pag(val) {
      this.pageNum = val.pageNum;
      this.pageSize = val.pageSize;
      this.fullscreenLoading = true;
      this.load(2);
    },
    timec(i) {
      this.nowtime = i;
      this.stat = 1;
      this.fullscreenLoading = true;
      this.load(2);
    },
    reset() {
      this.$router.push("/refresh");
    },
    load(type) {
      let userdata = JSON.parse(sessionStorage.getItem("userdata"));
      this.$set(this, "userdata", userdata);
      let data = {};
      let url = "";
      let newar = "";
      let newtime = "";
      if (this.nowtime == "") {
        if (this.zctime == "") {
          newtime = "";
        } else {
          newtime = this.zctime.join(",");
        }
      } else {
        newtime = this.nowtime;
      }
      if (this.areaId == "") {
        newar = userdata.areasId;
        this.level = userdata.level;
        url = `/api-r/statistics/getBanquetStaticsData`;
      } else {
        newar = this.areaId;
        this.level = this.level;
        url = `/api-r/statistics/getBanquetStaticsData`;
      }
      if (this.stat == 1) {
        data = this.$qs.stringify({
          area: newar,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          time: newtime,
          level: this.level,
        });
      } else {
        data = this.$qs.stringify({
          area: userdata.areasId,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          time: newtime,
          level: userdata.level,
        });
        url = `/api-r/statistics/getBanquetStaticsData`;
      }
      this.$axios
        .post(url, data, { headers: { accessToken: userdata.token } })
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.success) {
            // console.log(res)
            this.$set(this, "chart", res.data.pageInfo.list);

            let arr = res.data.pageInfo.list;
            let obj = {
              areaName: "合计",
              total1: "",
              total2: "",
              total3: "",
              total4: "",
            };
            arr.forEach((x) => {
              obj.total1 = Number(obj.total1) + Number(x.total1);
              obj.total2 = Number(obj.total2) + Number(x.total2);
              obj.total3 = Number(obj.total3) + Number(x.total3);
              obj.total4 = Number(obj.total4) + Number(x.total4);
            });
            arr.push(obj);
            this.$set(this, "tableData6", arr);
            this.$set(this, "listnum", res.data.pageInfo.total);
            if (type != 2) {
              this.$Public.NumAutoPlusAnimation("time1", {
                time: 1000, //总时间
                num: res.data.banquetCount , //结束数
                regulator: 8, //调速器
                count: 0,
              });
              this.$Public.NumAutoPlusAnimation("time2", {
                time: 1000, //总时间
                num: res.data.checkCount , //结束数
                regulator: 8, //调速器
                count: 0,
              });
              this.$Public.NumAutoPlusAnimation("time3", {
                time: 1000, //总时间
                num: res.data.banquetDeskCount , //结束数
                regulator: 8, //调速器
                count: 0,
              });
              this.$Public.NumAutoPlusAnimation("time4", {
                time: 1000, //总时间
                num: res.data.peopleTotal , //结束数
                regulator: 8, //调速器
                count: 0,
              });
              // this.$set(this, "total", res.data);
              setTimeout(() => {
                this.statistics.bb = res.data.banquetCount;
                this.statistics.cs = res.data.checkCount;
                this.statistics.zs = res.data.banquetDeskCount;
                this.statistics.rs = res.data.peopleTotal;
              }, 4500);
            } else {
              document.getElementById("time1").innerHTML =
                res.data.banquetCount;
              document.getElementById("time2").innerHTML = res.data.checkCount;
              document.getElementById("time3").innerHTML =
                res.data.banquetDeskCount;
              document.getElementById("time4").innerHTML = res.data.peopleTotal;
              this.statistics.bb = res.data.banquetCount;
              this.statistics.cs = res.data.checkCount;
              this.statistics.zs = res.data.banquetDeskCount;
              this.statistics.rs = res.data.peopleTotal;
            }
            this.seekCity = res.data.mergerName;
            if (this.stat == 1) {
              this.$message({
                type: "success",
                message: res.data.msg,
              });
            }
            let myChart1 = echarts.init(
              document.getElementById("main1"),
              "light"
            );
            let option = {
              tooltip: {
                trigger: "axis",
                axisPointer: {
                  // 坐标轴指示器，坐标轴触发有效
                  type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
                },
              },
              legend: {
                data: ["办宴数", "检查数", "办宴桌数", "参宴人数"],
              },
              grid: {
                left: "3%",
                right: "4%",
                bottom: "3%",
                containLabel: true,
              },
              dataZoom: [
                {
                  type: "slider", //数据滑块
                  start: 0,
                  end: 60,
                  height: "10px",
                  minSpan: 8,

                  dataBackground: {
                    lineStyle: {
                      color: "#fff",
                    },
                    areaStyle: {
                      color: "#fff",
                      opacity: 1,
                    },
                  },
                },
                {
                  type: "inside", //使鼠标在图表中时滚轮可用
                },
              ],
              grid: {
                bottom: "75px",
              },
              xAxis: [
                {
                  type: "category",
                  data: [
                    "周一",
                    "周二",
                    "周三",
                    "周四",
                    "周五",
                    "周六",
                    "周日",
                  ],
                },
              ],
              yAxis: [
                {
                  type: "value",
                },
              ],
              series: [
                {
                  name: "办宴数",
                  type: "bar",
                  data: [320, 332, 301, 334, 390, 330, 320],
                },
                {
                  name: "检查数",
                  type: "bar",
                  data: [120, 132, 101, 134, 90, 230, 210],
                },
                {
                  name: "办宴桌数",
                  type: "bar",
                  data: [220, 182, 191, 234, 290, 330, 310],
                },
                {
                  name: "参宴人数",
                  type: "bar",
                  // stack: '广告',    // 是否重叠
                  data: [150, 232, 201, 154, 190, 330, 410],
                },
              ],
            };
            let arr1 = [];
            let arr2 = [];
            let arr3 = [];
            let arr4 = [];
            let arr5 = [];
            let arr6 = [];
            let arr7 = [];
            this.chart.forEach((x) => {
              arr1.push(x.areaName);
              arr2.push(x.total1);
              arr3.push(x.total2);
              arr4.push(x.total3);
              arr5.push(x.total4);
            });
            option.xAxis[0].data = arr1;
            option.series[0].data = arr2;
            option.series[1].data = arr3;
            option.series[2].data = arr4;
            option.series[3].data = arr5;
            myChart1.setOption(option);
          } else {
            this.$message(res.data.msg);
          }
        });
    },
    parentFn(i) {
      this.areaId = i.id;
      this.level = i.level;
      // this.seekCity = i.name
    },
    time() {
      console.log(this.zctime);
    },
    query() {
      this.stat = 1;
      this.nowtime = "";
      this.fullscreenLoading = true;
      this.load(2);
    },
  },
};
</script>
<style>
#byan .newbb .el-card__body {
  display: flex;
  align-items: center;
}
#byan .el-table td,
.el-table th.is-leaf {
  text-align: center;
}
#byan .el-table th > .cell {
  font-size: 14px;
  color: #666;
}
/* 暂无数据样式 */
#byan .el-table__empty-text {
  display: block;
  width: 500px;
  height: 240px;
  padding-top: 126px;
  background: url(../../assets/img/nothing.svg) no-repeat 50%;
  color: #909399;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 12px;
}
/* #byan .el-pagination{
        margin: 22px 0;
        float: right
    } */
#byan .el-pagination__sizes .el-select {
  margin-top: -12px;
}
#byan .el-table .re {
  color: #11A983;
  font-weight: 800;
}
#byan .el-select > .el-input {
  margin: 0px 0 18px;
}
</style>
<style scoped lang="scss">
.bdechart {
  width: 100% !important;
  margin-top: 24px;
}
.overview {
  display: flex;
  // justify-content: space-around;
  text-align: center;
  border: 1px solid rgb(238, 238, 238);
  margin-bottom: 12px;
  & > p {
    width: 26%;
    border-right: 1px solid rgb(238, 238, 238);
  }
  & > p:nth-of-type(4) {
    width: 26%;
    border-right: none;
  }
  & > p > span {
    display: block;
    width: 100%;
    line-height: 20px;
    line-height: 50px;
    & > i {
      color: #11A983;
      font-size: 36px;
      font-weight: 600;
    }
  }
}
.newbbtit {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.mgr {
  margin-right: 3px;
}
</style>
